














































import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
import filterUtils from '@/common/filterUtils';
import { SubscriptionInfo } from '@/models/Subscription';
import dayjs from 'dayjs';

@Component
export default class SavedCardForm extends Vue {
  @Prop()
  msgSavedCardInfo!: SubscriptionInfo;
  year = dayjs()
    .format('YYYY')
    .substring(0, 2);
  @PropSync('savedCardHolderName')
  syncedHolderName!: string;
  // カード情報入力部分を非活性化
  @Prop()
  savedCardDisableFlag!: boolean;
  // カード名義の非表示指定
  @Prop()
  hideCardHolderNameFlag!: boolean;

  // カード情報入力部分のプレースホルダ
  readonly CREDIT_CARD_HOLDER_NAME_PLACEHOLDER = 'TARO ODAKYU';
  //カード情報入力部分のdata-vv-name
  readonly CARD_HOLDER_NAME = 'カード名義';

  created() {
    this.initialize();
  }

  initialize() {
    this.validatorLocalize();
  }

  // バリデーションエラーのアラート文変更
  validatorLocalize() {
    const dict = {
      custom: {
        // カード番号
        cardHolderNameForSavedCard: {
          min: 'カード名義は2文字以上をご入力ください',
          regex: 'カード名義は半角英数記号でご入力ください'
        }
      }
    };
    this.$validator.localize('ja', dict);
  }

  // ユーザ入力情報のバリデーション
  async formatCardHolderName() {
    this.syncedHolderName = filterUtils.funcs.formatToHalfUpperCase(
      this.syncedHolderName || ''
    );
    await this.$nextTick();
    this.$validator.validate('cardHolderNameForSavedCard');
  }
}
